/**
 * Contribution Detail adapter.
 *
 * The pure aggregation (void exclusion, NaN/rounding guards, anonymous/guest
 * resolution, fund/batch fallbacks, totals) lives in
 * @glorify-llc/accounting-core and is shared with Relay (ADR-006). This file
 * keeps the Forge-specific seam: it composes the summary. Unlike the
 * registry-backed adapters, these three labels are NOT registry-driven — they are
 * hardcoded here exactly as they were before the split, so the golden test that
 * asserts the labels + values stays green.
 *
 * Consumers keep importing from "@/lib/reports/adapters/contribution-detail".
 */
import type { ReportAggregation } from "@glorify-llc/accounting-core";
import {
  aggregateContributionDetail,
  type ContributionDetailContext,
} from "@glorify-llc/accounting-core";

export type {
  ContributionDetailContext,
  DetailContribution,
  DetailAllocation,
} from "@glorify-llc/accounting-core";

export function buildContributionDetailAggregation(
  context: ContributionDetailContext,
): ReportAggregation {
  const { rows, totalContributions, uniqueDonors, averageGift } =
    aggregateContributionDetail(context);

  return {
    asOf: context.asOf,
    summary: [
      { label: "Total Contributions", value: totalContributions },
      { label: "Unique Donors", value: uniqueDonors },
      { label: "Average Gift", value: averageGift },
    ],
    rows,
  };
}
